export const adminUsers = {
  'admin.users.title': 'Gestione Utenti',
  'admin.users.subtitle': 'Gestire e monitorare account utente, statistiche e performance',
  'admin.users.loading': 'Caricamento...',
  'admin.users.error': 'Errore nel caricamento dei dati utenti',
  'admin.users.noData': 'Nessun dato disponibile',
  'admin.users.cards.totalUsers.title': 'Totale Utenti',
  'admin.users.cards.totalUsers.active': 'Attivo',
  'admin.users.cards.totalUsers.inactive': 'Inattivo',
  'admin.users.cards.monthlyUsers.title': 'Nuovi Utenti Questo Mese',
  'admin.users.cards.monthlyUsers.dailyRegistrations': 'Registrazioni di Oggi',
  'admin.users.cards.usersWithoutAccounts.title': 'Utenti Senza Account',
  'admin.users.cards.usersWithoutAccounts.withInactiveAccounts': 'Utenti Con Account Inattivi',
  'admin.users.cards.countryDistribution.title': 'Paesi Principali',
  'admin.users.cards.countryDistribution.topCountry': 'Paese Principale',
  'admin.users.cards.countryDistribution.usersCount': 'Numero Utenti',
  'admin.users.cards.countryDistribution.noData': 'Nessun dato disponibile',
  'admin.users.cards.topEarnersCombined.title': 'Top Guadagni Combinati',
  'admin.users.cards.topEarnersCombined.description': 'Trading + Profitti Commissioni',
  'admin.users.cards.topEarnersAccounts.title': 'Top Guadagni Account Trading',
  'admin.users.cards.topEarnersAccounts.description': 'Profitti Account Trading',
  'admin.users.cards.topEarnersCommissions.title': 'Top Guadagni Commissioni',
  'admin.users.cards.topEarnersCommissions.description': 'Profitti Commissioni Comunità',
  'admin.users.tables.recent.title': 'Utenti Recenti (Ultimi 7 Giorni)',
  'admin.users.tables.inactive.title': 'Utenti Inattivi',
  'admin.users.tables.no_accounts.title': 'Utenti Senza Account',
  'admin.users.tables.inactive_accounts.title': 'Utenti con Account Inattivi',
  'admin.users.tables.columns.username': 'Nome Utente',
  'admin.users.tables.columns.name': 'Nome',
  'admin.users.tables.columns.country': 'Paese',
  'admin.users.tables.columns.status': 'Stato',
  'admin.users.tables.columns.joinedAt': 'Iscritto Il',
  'admin.users.tables.columns.accountCreationDate': 'Creazione Account',
  'admin.users.tables.columns.accountNumber': 'Numero Account',
  'admin.users.tables.columns.accountStatus': 'Stato Account',
  'admin.users.tables.columns.actions': 'Azioni',
  'admin.users.tables.status.active': 'Attivo',
  'admin.users.tables.status.inactive': 'Inattivo',
  'admin.users.tables.accountStatus.active': 'Attivo',
  'admin.users.tables.accountStatus.inactive': 'Inattivo',
  'admin.users.tables.accountStatus.pending': 'In Attesa',
  'admin.users.tables.accountStatus.suspended': 'Sospeso',
  'admin.users.tables.accountStatus.closed': 'Chiuso',
  'admin.users.tables.pagination.previous': 'Precedente',
  'admin.users.tables.pagination.next': 'Successivo',
  'admin.users.tables.pagination.loadMore': 'Carica Altro',
  'admin.users.tables.pagination.showing': 'Mostrando',
  'admin.users.tables.pagination.of': 'di',
  'admin.users.tables.pagination.results': 'risultati',
  'admin.users.tables.pagination.page': 'Pagina',
  'admin.users.tables.error': 'Errore caricamento dati tabella',
  'admin.users.tables.noData': 'Nessun dato disponibile',
  'admin.users.tables.noAccount': 'Nessun Account',
  'admin.users.tables.unknown': 'Sconosciuto',
  'admin.users.tables.viewProfile': 'Visualizza Profilo',
  // Search page translations
  'admin.users.search.title': 'Ricerca Utenti',
  'admin.users.search.subtitle': 'Cerca e trova utenti per vari criteri',
  'admin.users.search.form.userInfo.label': 'Informazioni Utente',
  'admin.users.search.form.userInfo.placeholder': 'Cerca per nome utente, nome, email o telefono...',
  'admin.users.search.form.country.label': 'Paese',
  'admin.users.search.form.country.placeholder': 'Seleziona un paese...',
  'admin.users.search.form.country.all': 'Tutti i Paesi',
  'admin.users.search.form.searchButton': 'Cerca',
  'admin.users.search.form.clearButton': 'Cancella',
  'admin.users.search.results.title': 'Risultati Ricerca',
  'admin.users.search.results.noResults': 'Nessun utente trovato che corrisponde ai tuoi criteri',
  'admin.users.search.results.loading': 'Ricerca utenti...',
  'admin.users.search.results.error': 'Errore nella ricerca utenti',
  'admin.users.search.results.showEmail': 'Mostra Email',
  'admin.users.search.results.hideEmail': 'Nascondi Email',
  'admin.users.search.results.showPhone': 'Mostra Telefono',
  'admin.users.search.results.hidePhone': 'Nascondi Telefono',
  'admin.users.search.results.columns.email': 'Email',
  'admin.users.search.results.columns.phone': 'Telefono',
  
  // Profile page
  'admin.users.profile.title': 'Profilo Utente',
  'admin.users.profile.subtitle': 'Visualizza informazioni dettagliate utente e impostazioni',
  'admin.users.profile.error.userNotFound': 'Utente non trovato. Il nome utente specificato non esiste.',
  'admin.users.profile.loading': 'Caricamento profilo utente...',
  
  // Profile information section
  'admin.users.profile.info.title': 'Informazioni Profilo',
  'admin.users.profile.info.username': 'Nome Utente',
  'admin.users.profile.info.name': 'Nome',
  'admin.users.profile.info.status': 'Stato Utente',
  'admin.users.profile.info.memberSince': 'Membro Da',
  'admin.users.profile.info.sponsor': 'Sponsor',
  'admin.users.profile.info.referralLink': 'Link Referral',
  'admin.users.profile.info.commissionModel': 'Modello Commissioni',
  'admin.users.profile.info.country': 'Paese',
  'admin.users.profile.info.domain': 'Dominio',
  'admin.users.profile.info.internalCommissionModel': 'Modello Commissioni Interno',
  'admin.users.profile.info.communityLevel': 'Livello Comunità',
  'admin.users.profile.info.genealogyTree': 'Albero Genealogico Comunità',
  'admin.users.profile.info.openUserTree': 'Apri Albero Utente',
  'admin.users.profile.info.copyReferralLink': 'Copia Link Referral',
  'admin.users.profile.info.viewSponsor': 'Visualizza Profilo Sponsor',
  'admin.users.profile.info.noData': 'Le informazioni del profilo non sono disponibili.',
  
  // User status editing
  'admin.users.profile.status.editButton': 'Modifica Stato',
  'admin.users.profile.status.saveButton': 'Salva',
  'admin.users.profile.status.cancelButton': 'Annulla',
  'admin.users.profile.status.saving': 'Salvataggio...',
  'admin.users.profile.status.active': 'Attivo',
  'admin.users.profile.status.inactive': 'Inattivo',
  'admin.users.profile.status.updateSuccess': 'Stato Aggiornato',
  'admin.users.profile.status.updateSuccessDescription': 'Lo stato dell\'utente è stato aggiornato con successo.',
  'admin.users.profile.status.updateError': 'Aggiornamento Fallito',
  'admin.users.profile.status.updateErrorDescription': 'Impossibile aggiornare lo stato dell\'utente. Riprova.',
  
  // Private information section
  'admin.users.profile.private.title': 'Informazioni Private',
  'admin.users.profile.private.subtitle': 'Dettagli personali riservati dell\'utente',
  'admin.users.profile.private.email': 'Email',
  'admin.users.profile.private.phone': 'Numero di Telefono',
  'admin.users.profile.private.gender': 'Genere',
  'admin.users.profile.private.noData': 'Le informazioni private non sono disponibili.',
  
  // Payment methods section
  'admin.users.profile.payment.title': 'Metodi di Pagamento',
  'admin.users.profile.payment.subtitle': 'Opzioni di pagamento configurate dell\'utente',
  'admin.users.profile.payment.crypto.title': 'Portafoglio Cripto',
  'admin.users.profile.payment.crypto.network': 'Rete',
  'admin.users.profile.payment.crypto.currency': 'Valuta',
  'admin.users.profile.payment.crypto.address': 'Indirizzo',
  'admin.users.profile.payment.noData': 'Nessun metodo di pagamento configurato.',

  // User Accounts Section
  profileUserAccounts: 'Conti Utente',
  profileUserAccountsSubtitle: 'Conti di trading e dettagli degli investimenti',
  profileAccountsTableAccountNumber: 'Numero Conto',
  profileAccountsTableAccountStatus: 'Stato Conto', 
  profileAccountsTableAccountType: 'Tipo Conto',
  profileAccountsTableProgramPercent: 'Percentuale Programma',
  profileAccountsTableBalance: 'Saldo',
  profileAccountsTableCreationDate: 'Creazione Conto',
  profileAccountsTableNoData: 'Nessun dato conto disponibile',
  profileAccountsTableError: 'Errore nel caricamento dati conti',

  // User Earnings Section
  profileUserEarnings: 'Informazioni Guadagni Utente',
  profileUserEarningsSubtitle: 'Panoramica completa di guadagni e profitti', 
  profileEarningsError: 'Errore nel caricamento dati guadagni',
  profileEarningsNoData: 'Nessun dato guadagni disponibile',
  
  // Admin profile earnings keys
  'admin.users.profile.earnings.title': 'Informazioni Guadagni Utente',
  'admin.users.profile.earnings.subtitle': 'Panoramica completa di guadagni e profitti',
  
  // Historic Earnings Section
  'admin.users.profile.historicEarnings.title': 'Informazioni Storiche Guadagni Utente',
  'admin.users.profile.historicEarnings.subtitle': 'Vista storica completa di conti e guadagni commissioni',
  'admin.users.profile.historicEarnings.error.userIdRequired': 'ID utente richiesto per caricare dati guadagni',
  'admin.users.profile.historicEarnings.accountsHistory.title': 'Cronologia Profitti Conti',
  'admin.users.profile.historicEarnings.accountsHistory.subtitle': 'Dati storici profitti da conti investimento utente',
  'admin.users.profile.historicEarnings.accountsHistory.error': 'Errore caricamento cronologia profitti conti',
  'admin.users.profile.historicEarnings.commissionsHistory.title': 'Cronologia Guadagni Commissioni',
  'admin.users.profile.historicEarnings.commissionsHistory.subtitle': 'Guadagni storici commissioni da rete referral',
  'admin.users.profile.historicEarnings.commissionsHistory.error': 'Errore caricamento cronologia guadagni commissioni',
  
  // Payment History Section
  'admin.users.profile.paymentHistory.title': 'Cronologia Pagamenti Utente',
  'admin.users.profile.paymentHistory.subtitle': 'Registro completo pagamenti commissioni e transazioni',
  'admin.users.profile.paymentHistory.error.userIdRequired': 'ID utente richiesto per caricare dati pagamenti',
  'admin.users.profile.paymentHistory.error.loadingData': 'Errore caricamento dati cronologia pagamenti',

  // Admin Community Levels
  'admin.users.communityLevels.title': 'Livelli della Comunità',
  'admin.users.communityLevels.subtitle': 'Esplora la struttura della comunità per livelli gerarchici',
  'admin.users.communityLevels.targetUser': 'Utente Target',
  'admin.users.communityLevels.level': 'Livello',
  'admin.users.communityLevels.members': 'membri',
  'admin.users.communityLevels.total': 'totale',
  'admin.users.communityLevels.active': 'Attivo',
  'admin.users.communityLevels.inactive': 'Inattivo',
  'admin.users.communityLevels.treeLevel': 'Livello Albero',
  'admin.users.communityLevels.directReferrals': 'Referral Diretti',
  'admin.users.communityLevels.memberSince': 'Membro Dal',
  'admin.users.communityLevels.username': 'Nome Utente',
  'admin.users.communityLevels.name': 'Nome',
  'admin.users.communityLevels.country': 'Paese',
  'admin.users.communityLevels.joinDate': 'Data di Iscrizione',
  'admin.users.communityLevels.status': 'Stato',
  'admin.users.communityLevels.loading': 'Caricamento...',
  'admin.users.communityLevels.loadMore': 'Carica Altri',
  'admin.users.communityLevels.noMembers': 'Nessun membro trovato per questo livello',
  'admin.users.communityLevels.errorLoading': 'Errore nel caricamento dei dati del livello',
  'admin.users.communityLevels.errorLoadingData': 'Errore nel caricamento dei dati della comunità',
  'admin.users.communityLevels.userNotFound': 'Utente non trovato',
  'admin.users.communityLevels.noCommunityData': 'Nessun dato della comunità disponibile',
  'admin.users.communityLevels.filters': 'Filtri',
  'admin.users.communityLevels.statusFilter': 'Filtro Stato',
  'admin.users.communityLevels.rankFilter': 'Filtro Rango',
  'admin.users.communityLevels.allStatuses': 'Tutti gli Stati',
  'admin.users.communityLevels.allRanks': 'Tutti i Ranghi',
  'admin.users.communityLevels.communityStructure': 'Struttura della Comunità',
};